import { render, staticRenderFns } from "./Suspensao.vue?vue&type=template&id=162287b3"
import script from "./Suspensao.vue?vue&type=script&lang=js"
export * from "./Suspensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports